<input
  #fileInput
  type="file"
  accept="image/*"
  style="display: none"
  (change)="onUpload()"
  />

<app-modal
  #deleteProfilePhotoModal
  [modalTitle]="app.text.app.confirm"
  [modalMessage]="app.text.app.deleteProfilePicture"
  (ok)="onDelete()"
  >
</app-modal>

<app-modal
  #discardChangesModal
  [modalMessage]="app.text.profile.discard"
  [modalTitle]="app.text.profile.modalTitle"
  (ok)="discardDetails()"
  >
</app-modal>
@if (!app.profile.viewProfile) {
  <div class="row col-md-12" >
    <div class="col-xl-4 col-md-12 col-sm-12 pictureSection">
      <div class="my-3">
        <div class="col-md-12">
          <div class="legend">{{ app.text.profile.profileImg }}</div>
        </div>
        @if (name != null) {
          <div>
            <div class="text-center">
              @if (app.profile.userProfilePicture != '') {
                <img
                  class="userImage"
                  target="_blank"
                  [src]="app.file.getUrl(app.profile.userProfilePicture)"
                  />
              }
              @if (app.profile.userProfilePicture === '') {
                <img
                  class="userImage"
                  target="_blank"
                  [src]="app.url.profile.defaultImage"
                  />
              }
              <div class="deteleIcons">
                @if (
                  own &&
                  app.profile.userProfilePicture === '' &&
                  checkPermissions(name)
                  ) {
                  <button
                    class="btn btn-sm btn-image"
                    (click)="fileInput.click()"
                    [title]="app.text.profile.uploadImage"
                    [disabled]="app.unlockedId != null"
                    >
                    <i class="fa fa-upload"></i>
                  </button>
                }
                @if (
                  own &&
                  app.profile.userProfilePicture !== '' &&
                  checkPermissions(name) &&
                  app.unlockedId == null
                  ) {
                  <button
                    class="btn btn-sm btn-image"
                    (click)="deleteProfilePhotoModal.open()"
                    [title]="app.text.profile.deleteImage"
                    [disabled]="app.unlockedId != null"
                    >
                    <i class="fa fa-trash"></i>
                  </button>
                }
              </div>
            </div>
            <div class="text-center name">
              {{ fullName }}
            </div>
          </div>
        }
        <div class="col-md-12">
          @if (own && app.unlockedId === null) {
            <div>
              <div class="legend">
                {{ app.text.profilePassword.passwordChange }}
              </div>
              <app-password></app-password>
            </div>
          }
        </div>
        <!-- Security -->
        @if (app.profile.showSecuritySection()) {
          <div class="col-md-12">
            @if (own && app.unlockedId === null) {
              <div>
                <div class="legend">{{ app.text.userSettings.security }}</div>
                @if (
                  name === app.user &&
                  app.userSettings.userSettings.mfaPreferences
                  ) {
                  <div
                    class="col-md-12"
                    >
                    <div class="m-2">
                      <div class="m-2 d-flex align-items-center">
                        <button
                          class="btn"
                          (click)="app.userSettings.setMFAPreferences()"
                          [disabled]="app.profile.canEdit2FAForUser()"
                          >
                          @if (app.userSettings.userSettings.mfaPreferences.email) {
                            <i
                              class="fa fa-toggle-on check-on"
                            ></i>
                          }
                          @if (!app.userSettings.userSettings.mfaPreferences.email) {
                            <i
                              class="fa fa-toggle-off check-off"
                            ></i>
                          }
                        </button>
                        <label class="fieldNameC">{{
                          app.text.userSettings.MFAEmail
                        }}</label>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        <!-- Language Change  -->
        @if (app.customer !== 'oc') {
          <div>
            @if (own && app.unlockedId === null) {
              <div>
                <div class="legend">{{ app.text.profile.language }}</div>
                @if (name === app.user) {
                  <div
                    class="languages-container m-4"
                    >
                    @for (language of app.languages; track language) {
                      <div class="btn-group">
                        @if (app.customer !== 'ns' && language !== 'nl') {
                          <button
                            class="btn btn-sm language-btn"
                            [ngClass]="{ 'selected-language': language === app.language }"
                (click)="
                  app.language = language; app.users.setLanguage(language)
                "
                            >
                            {{ language | uppercase }}
                          </button>
                        }
                        @if (app.customer === 'ns') {
                          <button
                            class="btn btn-sm language-btn"
                            [ngClass]="{ 'selected-language': language === app.language }"
                (click)="
                  app.language = language; app.users.setLanguage(language)
                "
                            >
                            {{ language | uppercase }}
                          </button>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-xl-7 col-md-12 col-sm-12 detailSection">
      <div class="pb-2 my-3">
        <div class="col-md-12">
          <div class="legend">{{ app.text.profile.profileInfo }}</div>
        </div>
        <div class="row p-2">
          <div class="pull-right">
            <div class="controls">
              <app-unlock [id]="name" [permission]="checkPermissions(name)">
                <button
                  class="btn btn-sm btn-clean"
                  [title]="app.text.profile.close"
                  (click)="dismissModal()"
                  >
                  <i class="fas fa-times close-icon"></i>&nbsp;
                  {{ app.text.post.cancel }}
                </button>
              </app-unlock>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            @for (field of personProfileFields; track field; let index = $index) {
              <app-field
                [model]="app.profile.profileWithSections"
                [field]="field"
                [index]="index"
                [publicFieldName]="app.fieldId.personProfile.publicFields"
                [disabled]="app.isLocked(name)"
                [noStriped]="true"
                [shadowInput]="true"
                >
              </app-field>
            }
          </div>
          <div class="col-6">
            @for (
              field of app.list.organizationProfile.organizationProfile; track
              field; let index = $index) {
              <app-field
                [model]="app.profile.profileWithSections"
                [field]="field"
                [index]="index"
                [publicFieldName]="app.fieldId.organizationProfile.publicFields"
                [disabled]="app.isLocked(name)"
                [noStriped]="true"
                [shadowInput]="true"
                >
              </app-field>
            }
          </div>
        </div>
        <div class="row centeredRow mt-5">
          @if (app.unlockedId != null) {
            <div
              class="col-md-6 text-center saveBtn"
              (click)="app.profile.updateProfile(); app.unlockedId = null"
              >
              <button class="saveBtn" [disabled]="!modelHasChanges()">
                {{ app.text.user.edit }}
              </button>
            </div>
          }
        </div>
      </div>
      @if (showEmailsBox()) {
        <div>
          @if (app.unlockedId == null) {
            <div class="pb-2 my-3">
              <div class="col-md-12">
                <div class="legend">
                  {{ app.text.userSettings.emailPreferences }}
                </div>
              </div>
              <!-- //Settings -->
              <div class="row">
                <div class="col-md-12">
                  <app-user-settings></app-user-settings>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!-- Badge system -->
      @if (app.customer === 'oc') {
        <div>
          <div class="pb-2 my-3">
            <div class="legend">My Badges</div>
            @for (badge of app.OCHome.badges; track badge) {
              <div class="m-2">
                <i class="fa-solid fa-medal fa-fw" [style.color]="badge.color"></i>
                <span class="label"> {{ badge.text.en }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
<!-- If current view is view mode only -->
@if (app.profile.viewProfile) {
  <div class="row fixed">
    <div class="col-md-12">
      <div class="d-flex">
        <button
          class="btn btn-control me-auto p-2"
          (click)="app.profile.viewProfile = false"
          >
          <i class="far fa-times"></i> &nbsp; {{ app.text.user.closeWindow }}
        </button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="col profilePicture">
        @if (name != null) {
          <div>
            <div class="text-center">
              @if (app.profile.userProfilePicture != '') {
                <img
                  class="userImage"
                  target="_blank"
                  [src]="app.file.getUrl(app.profile.userProfilePicture)"
                  />
              }
              @if (app.profile.userProfilePicture === '') {
                <img
                  class="userImage"
                  target="_blank"
                  [src]="app.url.profile.defaultImage"
                  />
              }
            </div>
            <div class="text-center my-2 name">
              {{ app.profile.selectedProfile }}
            </div>
            @if (app.profile.profileNotFound) {
              <div
                class="text-center my-2 disabledName"
                >
                *Profile deleted*
              </div>
            }
          </div>
        }
      </div>
      <div class="legend m-4">{{ app.text.profile.profileInfo }}</div>
      <div class="m-4 mb-0">
        @for (field of personProfileFields; track field; let i = $index) {
          <div
            div
            class="col-md-2 form-group"
            >
            <label class="font-size-12" for="name">{{
              app.field.getLabel(field)
            }}</label>
            @if (app.profile.profileWithSections[field] !== '') {
              <div
                class="value"
                >
                {{ app.profile.profileWithSections[field] }}
              </div>
            }
            @if (app.profile.profileWithSections[field] == '') {
              <div class="value">
                --
              </div>
            }
          </div>
        }
      </div>
      <div class="m-4 mt-0">
        @for (
          field of app.list.organizationProfile.organizationProfile; track
          field; let j = $index) {
          <div
            class="col-md-2 form-group"
            >
            <label class="font-size-12" for="name">{{
              app.field.getLabel(field)
            }}</label>
            @if (app.profile.profileWithSections[field] !== '') {
              <div
                class="value"
                >
                {{ app.profile.profileWithSections[field] }}
              </div>
            }
            <!-- <div
            class="value"
          *ngIf="
            app.profile.profileWithSections[field] == '' ||
            app.profile.profile.data === null || app.profile.data === ''
          "
            >
            --
          </div> -->
        </div>
      }
    </div>
  </div>
</div>
}
